import React, { useMemo, useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import { THEME } from 'GlobalStyles';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import FPIcon from 'UI/components/atoms/FPIcon';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import PhoneActionRow from 'UI/components/atoms/PhoneNumbersDropdown/PhoneActionRow';
import {
  getPhonesWithId,
  PHONE_TYPE_MAP,
  PHONE_TYPES
} from 'UI/components/organisms/PhoneNumbersForm/utils';
import { SvgMessageFilled } from 'UI/res';

const ICON_COLOR = THEME.palette.grey[600];
const DISABLED_COLOR = THEME.palette.grey[300];

const ROW_CLICK_BEHAVIOR = {
  Phone: 'phone',
  Text: 'text',
  None: 'none'
};

const ICON_VARIANT = {
  phone: 'phone',
  text: 'text'
};

export const PhoneNumbersMenu = ({
  contact,
  hidePhone = false,
  icon = ICON_VARIANT.text,
  onPhoneClick,
  onTextClick,
  rowClickBehavior = ROW_CLICK_BEHAVIOR.None,
  tooltipTitle = strings.messageCenter.newConversation.sendMessage
}) => {
  const canUseTextel = userHasPermission(Permissions.Textel.CanUseModule);
  const phones = contact.phones || [];
  const phone = contact.phone || contact.mobile || null;
  const ActionIcon = icon === ICON_VARIANT.phone ? PermPhoneMsgIcon : SvgMessageFilled;

  const [anchorEl, setAnchorEl] = useState(null);

  const uniquePhonesWithIds = useMemo(() => getPhonesWithId(phones), [phones]);

  const mainPhone =
    uniquePhonesWithIds.length > 0
      ? uniquePhonesWithIds[0]
      : { phone, use: null, type_id: null, country_code: '+1' };

  const handleClick = event => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleOnPhoneClick = phoneItem => {
    onPhoneClick && onPhoneClick({ contact, selectedPhone: phoneItem });
    handleClose();
  };

  const handleOnTextClick = phoneItem => {
    if (canUseTextel && phoneItem.type !== PHONE_TYPES.Land) {
      onTextClick && onTextClick({ contact, selectedPhone: phoneItem });
    }
    handleClose();
  };

  const handleOnRowClick = phoneItem => {
    if (rowClickBehavior === ROW_CLICK_BEHAVIOR.None) return;

    if (rowClickBehavior === ROW_CLICK_BEHAVIOR.Phone) {
      handleOnPhoneClick(phoneItem);
    } else if (rowClickBehavior === ROW_CLICK_BEHAVIOR.Text) {
      handleOnTextClick(phoneItem);
    }
  };

  return (
    <div>
      <FPIconButton
        tooltipProps={{ title: tooltipTitle }}
        onClick={handleClick}
        disabled={!mainPhone?.phone}
      >
        <FPIcon component={ActionIcon} color={mainPhone?.phone ? ICON_COLOR : DISABLED_COLOR} />
      </FPIconButton>
      <Menu id="phones-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {uniquePhonesWithIds.map(item => {
          const phoneType = PHONE_TYPE_MAP[item?.type_id];

          return (
            <MenuItem key={item.id} onClick={() => handleOnRowClick(item)}>
              <PhoneActionRow
                phone={item?.phone}
                type={phoneType}
                isDefault={item?.is_default}
                use={item?.use}
                onPhoneClick={() => handleOnPhoneClick(item)}
                onTextClick={() => handleOnTextClick(item)}
                hidePhone={hidePhone}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
